// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3419d5e3","455":"cb3474a6"}[chunkId] + ".chunk.js";
};